import React from "react";
import { Loader } from "./Loader";
import "./LoaderModal.scss";

export const LoaderModal = ({}) => {
  return (
    <div className="loader-modal">
      <Loader showText size={"large"} />
    </div>
  );
};
